"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInput = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _Input = require("../../../elements/input/Input");
var _react = _interopRequireWildcard(require("react"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _excluded = ["value", "onChange", "min", "max"];
var NumberInput = function NumberInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    min = _ref.min,
    max = _ref.max,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var handleValueChange = (0, _react.useCallback)(function (value) {
    onChange(value.floatValue, true);
  }, [onChange]);
  var isAllowed = (0, _react.useCallback)(function (_ref2) {
    var floatValue = _ref2.floatValue,
      value = _ref2.value;
    if (floatValue !== undefined) {
      if (min !== undefined && floatValue < min) {
        return false;
      }
      if (max !== undefined && floatValue > max) {
        return false;
      }
    }
    if (min !== undefined && min >= 0 && value.includes('-')) return false;
    return true;
  }, [max, min]);
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, Object.assign({
    customInput: _Input.Input,
    value: value,
    onValueChange: handleValueChange,
    isAllowed: isAllowed
  }, rest));
};
exports.NumberInput = NumberInput;